import { Form, Formik } from "formik";
import { FC, ReactElement, useCallback, useMemo, useState } from "react";

import BenefitSummary from "web/Pages/Checkout/Subscription/BenefitSummary/benefitSummary";
import { getInitialFormsValue } from "web/Pages/Customer/Content/Subscriptions/BenefitList/utils";

import { ModalActionTypes } from "web/hooks/useModal/useModalTypes";

import { getIdFromIri } from "web/utils/page/product/subscription/iri";

import restUrls from "web/constants/restUrls";

import { SimpleFn } from "web/types/Common";
import {
  ISubscriptionItemCurrentUserSubscription,
  ISubscriptionTotals,
} from "web/types/Subscription";

import { useAppContext } from "web/context/app";

interface IItemFormToFill {
  item: ISubscriptionItemCurrentUserSubscription;
  totals: ISubscriptionTotals;
  handleToggleEditModal: SimpleFn;
}

const ItemFormToFill: FC<IItemFormToFill> = ({
  item,
  totals,
  handleToggleEditModal,
}) => {
  const { modal } = useAppContext();
  const { dispatch } = modal;
  const [formsEditedByUsers, setFormsEditedByUsers] = useState([]);
  const [updatedItem, setUpdatedItem] = useState(item);
  const formInitialValues = useMemo(
    () => getInitialFormsValue(updatedItem || {}),
    [updatedItem]
  );

  const onSetModalHandler = useCallback(
    (content: ReactElement) => {
      dispatch({ type: ModalActionTypes.ADD_MODAL, modal: content });
    },
    [dispatch]
  );

  const itemWithId = { ...item, id: "" };
  itemWithId.id = getIdFromIri(item["@id"], restUrls.employeeSubscriptionItems);
  return (
    <Formik initialValues={formInitialValues} onSubmit={() => {}}>
      <Form>
        <BenefitSummary
          key={itemWithId["@id"]}
          wayChooseOthersInActiveForm={item.benefit.wayChooseOthersInActiveForm}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...itemWithId}
          items={[itemWithId]}
          setModal={onSetModalHandler}
          formView
          isMyBenefitsView
          handleItemUpdate={setUpdatedItem}
          handleToggleEditModal={handleToggleEditModal}
          formsEditedByUsers={formsEditedByUsers}
          setFormsEditedByUsers={setFormsEditedByUsers}
          totals={totals}
        />
      </Form>
    </Formik>
  );
};

export default ItemFormToFill;
